import { isBuyerView } from '@app/utils'

export const navigationFeatureEnabled = (): boolean => {
  return !isBuyerView()
}
